import React, { useEffect, useState } from "react";
import LocationSelectorForm from "./LocationSelectorForm.js";
import { useModal } from "../../../../Hooks/useModal.js";
import TextField from "../TextField.js";
import Modal from "../../../Modal/index.js";
import useWindowWidth from "../../../../Hooks/useWindowWidth.js";

const MultiLocationSelector = ({ locations, setLocations, locationList }) => {
  const [district, setDistrict] = useState("");
  const [division, setDivision] = useState("");
  const { isOpen, openModal, closeModal } = useModal();
  const [locationData, setLocationData] = useState([]);

  useEffect(() => {
    
    
    setDistrict("");
  }, [division]);

  useEffect(() => {
    const selectedDivision = locationList?.find((item) => item.divisionName === division);
    if (division?.length > 0) {
      const allUpazilas = selectedDivision?.district.flatMap((district) => district.upazila || []);
      setLocationData(allUpazilas);

      if (district === "Select District") {
        setLocationData(allUpazilas);
      } else if (district?.length > 0) {
        const selectedDistrict = selectedDivision?.district?.find(
          (d) => d.districtName === district
        );
        const upazilas = selectedDistrict?.upazila || [];
        setLocationData(upazilas);
      }
    } else {
      setLocationData([]);
    }
  }, [division, district, locationList]);

  const handleToggle = (item) => {
    setLocations((prev) => {
      const itemId = item.id || item.value;
      const isSelected = Object.values(prev)?.some(
        (i) => (i.id || i.value) === itemId
      );
      if (isSelected) {
        return Object.values(prev).filter((i) => (i.id || i.value) !== itemId);
      } else {
        return [...Object.values(prev), item];
      }
    });
  };

  const handleClose = () => {
    setDistrict("");
    setDivision("");
    closeModal();
  };

  const handleResetAll = () => {
    setLocations([]);
    setDistrict("");
    setDivision("");
  };

  const handleReset = () => {
    setLocations(prevLocations => prevLocations.filter(location => {
      const selectedDistrict = locationList
        .find(div => div.divisionName === division)
        ?.district.find(dist => dist.districtName === district);
      return !selectedDistrict?.upazila.some(upazila => upazila.id === location.id);
    }));
    
    setDistrict("");
    setLocationData([]);
  };



  const windowWidth = useWindowWidth();

  return (
    <div className="relative ">
      <div
        onClick={openModal}
        className="cursor-pointer z-[5] absolute w-full h-full inset-0 bg-transparent"
      ></div>
      <TextField
        label={"Select City/Cities"}
        value={locations.map((el) => ` ${el.locationName}`)}
        placeholder={"Click to to open selector"}

      />
      <Modal
        isOpen={isOpen}
        onClose={handleClose}
        openModal={openModal}
        style={{ width: windowWidth>=768?"70vw":"90vw", maxHeight:"90vh" }}
      >
        <LocationSelectorForm
          division={division}
          setDivision={setDivision}
          district={district}
          setDistrict={setDistrict}
          locationData={locationData}
          locations={locations}
          setLocations={setLocations}
          locationList={locationList}
          handleToggle={handleToggle}
          handleReset={handleReset}
          handleResetAll={handleResetAll}
          isOpen={isOpen}
          openModal={openModal}
          handleClose={handleClose}
        />
      </Modal>
    </div>
  );
};

export default MultiLocationSelector;

